import { ClassLevelAttributesListProps } from 'Types/Classes.types'
import { ClassLevelAttributesListItem } from 'Components/tasks/Classes/ClassLevelAttributesListItem'
import styles from './Classes.module.less'

export const ClassLevelAttributesList = (props: ClassLevelAttributesListProps) => {
    const annotations = props.getAnnotationsWithAttributes()

    if (!annotations.length) {
        return (
            <div className={styles['class-level-empty']}>
                No annotations with class-level attributes yet.
            </div>
        )
    }

    return (
        <div className={styles['class-level-cards-container']}>
            {annotations.map(annotation => (
                <ClassLevelAttributesListItem
                    key={annotation.id}
                    annotationId={annotation.id}
                    {...props}
                />
            ))}
        </div>
    )
}
